$(document).ready(function() {
  
  $('.custom_collection_slider').slick({
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    prevArrow:'<button class="custom_test_arrow prev-arrrow slider-button slider-button--prev"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10.0852 14.0669L4.46849 8.46693C4.40182 8.40026 4.35471 8.32804 4.32716 8.25026C4.29916 8.17248 4.28516 8.08915 4.28516 8.00026C4.28516 7.91137 4.29916 7.82804 4.32716 7.75026C4.35471 7.67248 4.40182 7.60026 4.46849 7.53359L10.0852 1.91693C10.2407 1.76137 10.4352 1.68359 10.6685 1.68359C10.9018 1.68359 11.1018 1.76693 11.2685 1.93359C11.4352 2.10026 11.5185 2.2947 11.5185 2.51693C11.5185 2.73915 11.4352 2.93359 11.2685 3.10026L6.36849 8.00026L11.2685 12.9003C11.424 13.0558 11.5018 13.2474 11.5018 13.4749C11.5018 13.7029 11.4185 13.9003 11.2518 14.0669C11.0852 14.2336 10.8907 14.3169 10.6685 14.3169C10.4463 14.3169 10.2518 14.2336 10.0852 14.0669Z" fill="#BFBFBF"/></svg></button>',
    nextArrow:'<button class="custom_test_arrow next-arrrow slider-button slider-button--next"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M5.91484 14.0669L11.5315 8.46693C11.5982 8.40026 11.6453 8.32804 11.6728 8.25026C11.7008 8.17248 11.7148 8.08915 11.7148 8.00026C11.7148 7.91137 11.7008 7.82804 11.6728 7.75026C11.6453 7.67248 11.5982 7.60026 11.5315 7.53359L5.91484 1.91693C5.75929 1.76137 5.56484 1.68359 5.33151 1.68359C5.09818 1.68359 4.89818 1.76693 4.73151 1.93359C4.56484 2.10026 4.48151 2.2947 4.48151 2.51693C4.48151 2.73915 4.56484 2.93359 4.73151 3.10026L9.63151 8.00026L4.73151 12.9003C4.57596 13.0558 4.49818 13.2474 4.49818 13.4749C4.49818 13.7029 4.58151 13.9003 4.74818 14.0669C4.91484 14.2336 5.10929 14.3169 5.33151 14.3169C5.55373 14.3169 5.74818 14.2336 5.91484 14.0669Z" fill="#BFBFBF"/></svg></button>',
    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  // Testimonial Slider js
  $('.testimonial-slider').slick({
    dots: false,
    arrow: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    prevArrow:'<button class="custom_test_arrow prev-arrrow slider-button slider-button--prev"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10.0852 14.0669L4.46849 8.46693C4.40182 8.40026 4.35471 8.32804 4.32716 8.25026C4.29916 8.17248 4.28516 8.08915 4.28516 8.00026C4.28516 7.91137 4.29916 7.82804 4.32716 7.75026C4.35471 7.67248 4.40182 7.60026 4.46849 7.53359L10.0852 1.91693C10.2407 1.76137 10.4352 1.68359 10.6685 1.68359C10.9018 1.68359 11.1018 1.76693 11.2685 1.93359C11.4352 2.10026 11.5185 2.2947 11.5185 2.51693C11.5185 2.73915 11.4352 2.93359 11.2685 3.10026L6.36849 8.00026L11.2685 12.9003C11.424 13.0558 11.5018 13.2474 11.5018 13.4749C11.5018 13.7029 11.4185 13.9003 11.2518 14.0669C11.0852 14.2336 10.8907 14.3169 10.6685 14.3169C10.4463 14.3169 10.2518 14.2336 10.0852 14.0669Z" fill="#BFBFBF"/></svg></button>',
    nextArrow:'<button class="custom_test_arrow next-arrrow slider-button slider-button--next"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M5.91484 14.0669L11.5315 8.46693C11.5982 8.40026 11.6453 8.32804 11.6728 8.25026C11.7008 8.17248 11.7148 8.08915 11.7148 8.00026C11.7148 7.91137 11.7008 7.82804 11.6728 7.75026C11.6453 7.67248 11.5982 7.60026 11.5315 7.53359L5.91484 1.91693C5.75929 1.76137 5.56484 1.68359 5.33151 1.68359C5.09818 1.68359 4.89818 1.76693 4.73151 1.93359C4.56484 2.10026 4.48151 2.2947 4.48151 2.51693C4.48151 2.73915 4.56484 2.93359 4.73151 3.10026L9.63151 8.00026L4.73151 12.9003C4.57596 13.0558 4.49818 13.2474 4.49818 13.4749C4.49818 13.7029 4.58151 13.9003 4.74818 14.0669C4.91484 14.2336 5.10929 14.3169 5.33151 14.3169C5.55373 14.3169 5.74818 14.2336 5.91484 14.0669Z" fill="#BFBFBF"/></svg></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  $(".grid_change_layout span.grid_layout-data").click(function() {
    $(this).addClass("active");
    $(".grid_change_layout span.list_layout_data").removeClass("active");
    $("div#ProductGridContainer").addClass("products-in-grid");
    $("div#ProductGridContainer").removeClass("products-in-list");
  });
  
  $(".grid_change_layout span.list_layout_data").click(function() {
    $(this).addClass("active");
    $(".grid_change_layout span.grid_layout-data").removeClass("active");
    $("div#ProductGridContainer").removeClass("products-in-grid");
    $("div#ProductGridContainer").addClass("products-in-list");
  });

  // TOGGLING NESTED ul
  $(".Categories_main-wrapp .selected a").click(function(e) {
    e.preventDefault();
    $(".Categories_main-wrapp .options ul").toggle();
  });

  // SELECT OPTIONS AND HIDE OPTION AFTER SELECTION
  $(".Categories_main-wrapp .options ul li a").click(function(e) {
      var text = $(this).html();
      $(".Categories_main-wrapp .selected a span").html(text);
      $(".Categories_main-wrapp .options ul").hide();
  });

  // HIDE OPTIONS IF CLICKED ANYWHERE ELSE ON PAGE
  $(document).bind('click', function(e) {
    var $clicked = $(e.target);
    if (! $clicked.parents().hasClass("Categories_main-wrapp"))
      $(".Categories_main-wrapp .options ul").hide();
  });

  $("section.pdp_custom_popup .close").click(function() {
    $("section.pdp_custom_popup").hide();
  });
  
  // Step form js
  $(".step-one-btn").click(function() {
    let email = document.forms["ContactForm"]["contact[email]"].value;
    if(email != "") {
      $(this).parents(".first-step-main").css("display", "none");
      $(".Second-step-main").css("display", "block");
    } else{
      alert("Please Enter the Valid Email");
    }
  });
   
  $(".step-two-btn").click(function() {
    let name = document.forms["ContactForm"]["contact[Nome]"].value;
    let last_name = document.forms["ContactForm"]["contact[Sobrenome]"].value;
    let phone = document.forms["ContactForm"]["contact[Telefone]"].value;
    let filter = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;
    if(name != "" && last_name != "" && phone != "" && filter.test(phone) && phone.length <= 12 && phone.length > 9 ) {
      $(this).parents(".Second-step-main").css("display", "none");
      $(".third-step-main").css("display", "block");
    } else{
      alert("Please Enter the All Details Correctly and make sure no field has an empty");
    }
  
  });
   
  $(".third-one-btn").click(function() {
    $(".Second-step-main").css("display", "block");
    $(".third-step-main").css("display", "none");
  });
   
  $(".third-one-btn").click(function() {
    $(".Second-step-main").css("display", "block");
    $(".third-step-main").css("display", "none");
  });
    
  $(".two-one-btn").click(function() {
    $(".first-step-main").css("display", "block");
    $(".Second-step-main").css("display", "none");
  });
});